import React, { PropTypes } from 'react';
import { connect } from 'react-redux';
import { fetchMonthToDate } from '../actions';
import LoadingPartial from './LoadingPartial';




const MonthToDateView = ( { onInit, status, data } ) => {
    console.log( 'here in the MonthToDate component! ', status)
    if ( status === 'init') onInit();
    if ( data ) {
        console.log( ' MONTH TO DATE COMPONENT NOW RENDERING! ', data)
        return (
            <div>
                <div className="row billing-summary">
                    <div className="col-sm-4 col-xs-6">
                        <div className="heading">MONTH ESTIMATE</div>
                        <div className="currency">${data.monthlyEstimate}</div>
                    </div>
                    <div className="col-sm-4 col-xs-6">
                        <div className="heading">MONTH TO DATE</div>
                        <div className="currency">${data.balance.toFixed(2)}</div>
                    </div>
                </div>
            </div>
        )
    } else {
        return <LoadingPartial/>
    }
}

const mapStateToProps = ( state ) => ({
    status: state.fetchMonthToDateRed.status,
    showLoading: state.fetchMonthToDateRed.showLoading,
    loadingMessage: state.fetchMonthToDateRed.loadingMessage,
    loadingMessage2: state.fetchMonthToDateRed.loadingMessage2,
    data: state.fetchMonthToDateRed.data,
    hasFailed: state.fetchMonthToDateRed.hasFailed,
});

const mapDispatchToProps = ( dispatch ) => ({
    onInit: ( status ) => {
        dispatch( fetchMonthToDate ( status ) )
    }
});

const MonthToDate = connect (
    mapStateToProps,
    mapDispatchToProps
) ( MonthToDateView );

export default MonthToDate;


/** WEBPACK FOOTER **
 ** ./src/components/MonthToDate.js
 **/